<template>
    <section class="named-timesheets">
        <fieldset :disabled="disabled || busy || loading">
        <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
        <div class="named-timesheets__row">
            <label class="named-timesheets__field">
                <span>Табель</span>
                <b-form-select v-model="selectedId" :disabled="disabled || busy || loading" :options="streamOptions" @change="$emit('select', $event)" />
            </label>
            <b-button v-if="selected" variant="primary" :disabled="busy || (!selected.timesheet_id && !selected.can_create)" @click="open">
                {{ selected.timesheet_id ? 'Открыть' : 'Начать месяц' }}
            </b-button>
        </div>
        <p v-if="selected" class="named-timesheets__responsible">Ответственный: {{ selected.responsible_name }}</p>
        <div v-if="canCreate" class="named-timesheets__row named-timesheets__create">
            <label class="named-timesheets__field">
                <span>Дополнительный табель</span>
                <b-form-input v-model.trim="newName" maxlength="200" placeholder="Например, ПТО или бригада Иванова"
                              aria-label="Название дополнительного табеля" />
            </label>
            <b-button :disabled="busy || !newName" variant="outline-primary" @click="create">Создать табель</b-button>
        </div>
        <details v-if="data.can_manage && selected">
            <summary>Название и ответственный</summary>
            <b-form-input v-model.trim="editName" aria-label="Название табеля" maxlength="200" />
            <v-select v-model="responsibleId" :options="data.users" label="text" :reduce="user => user.value"
                      :disabled="disabled || busy || loading"
                      placeholder="Ответственный" input-id="named-timesheet-responsible" />
            <small>Изменения применяются к черновикам и будущим месяцам. Отправленные табели сохраняют своего ответственного.</small>
            <b-button :disabled="busy || !responsibleId || !editName" @click="update">Сохранить</b-button>
        </details>
        </fieldset>
    </section>
</template>
<script>
import api from '@/utils/api';
export default {
    props: {buildingId: Number, month: String, canCreate: Boolean, currentStreamId: [Number, String], disabled: Boolean},
    data: () => ({data: {streams: [], users: []}, selectedId: null, newName: '', editName: '', responsibleId: null, busy: false, loading: false, error: '', requestId: 0}),
    computed: {
        streamOptions() { return [{value: null, text: 'Выберите именованный табель'}].concat(this.data.streams.map(row => ({
            value: row.id, text: `${row.name} · ${row.responsible_name || ''}${row.timesheet_id ? '' : ' · месяц не начат'}`
        }))); },
        selected() { return this.data.streams.find(row => Number(row.id) === Number(this.selectedId)); }
    },
    watch: {
        buildingId() { this.selectedId = null; this.load(); }, month() { this.load(); },
        currentStreamId(value) { this.selectedId = Number(value) || null; },
        selected(value) { this.editName = value ? value.name : ''; this.responsibleId = value ? value.responsible_user_id : null; }
    },
    mounted() { this.load(); },
    beforeDestroy() { this.requestId += 1; },
    methods: {
        hasUnsavedChanges() {
            return Boolean(this.newName || this.selected && this.data.can_manage && (
                this.editName !== this.selected.name || Number(this.responsibleId) !== Number(this.selected.responsible_user_id)
            ));
        },
        async load() {
            const request = ++this.requestId;
            this.loading = true;
            this.error = '';
            this.data = {streams: [], users: []};
            try {
                const response = await api.get('/api/timesheets/streams', {params: {building_id: this.buildingId, period_start: `${this.month}-01`}, ignoreModal: true});
                if (request !== this.requestId) return;
                this.data = response.data;
                if (this.data.streams.some(row => Number(row.id) === Number(this.currentStreamId))) this.selectedId = Number(this.currentStreamId);
            } catch (error) { if (request === this.requestId) this.fail(error); }
            finally { if (request === this.requestId) this.loading = false; }
        },
        fail(error) { this.error = error.response && error.response.data && error.response.data.msg || 'Не удалось обновить табели.'; },
        async open() {
            if (this.selected.timesheet_id) { this.$emit('open', this.selected.timesheet_id); return; }
            await this.ensure({stream_id: this.selected.id});
        },
        async create() { await this.ensure({create_named: true, name: this.newName}); },
        async ensure(extra) {
            this.busy = true; this.error = '';
            this.$emit('busy', true);
            try {
                const response = await api.post('/api/timesheets/drafts', {building_id: this.buildingId, period_start: `${this.month}-01`, ...extra}, {ignoreModal: true});
                this.newName = ''; await this.load();
                this.busy = false; this.$emit('busy', false); this.$emit('open', response.data.id);
            } catch (error) { this.fail(error); } finally { this.busy = false; this.$emit('busy', false); }
        },
        async update() {
            this.busy = true; this.error = '';
            this.$emit('busy', true);
            try {
                await api.put(`/api/timesheets/streams/${this.selectedId}`, {name: this.editName, responsible_user_id: this.responsibleId}, {ignoreModal: true});
                await this.load(); this.busy = false; this.$emit('busy', false); this.$emit('updated');
            } catch (error) { this.fail(error); } finally { this.busy = false; this.$emit('busy', false); }
        }
    }
};
</script>
<style scoped>
.named-timesheets { grid-column: 1 / -1; min-width: 0; padding-top: 1rem; border-top: 1px solid #e4eaf0; }
.named-timesheets fieldset { min-width: 0; }
.named-timesheets__row { display: flex; align-items: flex-end; gap: .75rem; }
.named-timesheets__field { display: block; flex: 1; min-width: 0; margin: 0; }
.named-timesheets__field > span { display: block; margin-bottom: .25rem; color: #526579; font-size: .8rem; font-weight: 700; }
.named-timesheets__row .btn { flex-shrink: 0; }
.named-timesheets__responsible { margin: .4rem 0 0; color: #687888; font-size: .85rem; }
.named-timesheets__create { margin-top: 1rem; }
.named-timesheets details > * { margin-top: .5rem; }
.named-timesheets details small { display: block; }
@media (max-width: 760px) {
    .named-timesheets__row { flex-direction: column; align-items: stretch; gap: .5rem; }
    .named-timesheets__row .btn { width: 100%; }
}
</style>
